import type { Dispatch } from "react";
import type { EngineSnapshot } from "@retreats/engine";
import type { UIAction, UIState } from "../bridge/types";
import type { EditableRetreatSchedule } from "@retreat/core";
import type { LiveScreenData } from "./useLiveScreenData";
import { useRetreatEvents } from "./useRetreatEvents";
import { useClickCapture } from "./useClickCapture";
import { useMissedBellBanner } from "./useMissedBellBanner";
import { useArmedWindow } from "./useArmedWindow";
import { useEngineTransitionLog } from "./useEngineTransitionLog";
import { RetreatState } from "../bridge/types";

export function useRetreatEventHandlers(
  snapshot: EngineSnapshot,
  uiState: UIState,
  liveData: LiveScreenData,
  dispatchUI: Dispatch<UIAction>,
  handlePreparationContinue: () => Promise<void>,
  activeSchedule: EditableRetreatSchedule,
  userId: string | null,
) {
  useRetreatEvents(
    snapshot,
    uiState,
    liveData,
    dispatchUI,
    handlePreparationContinue,
    activeSchedule,
    userId,
  );

  useEngineTransitionLog();
  useClickCapture();

  const missedBell = useMissedBellBanner(
    snapshot.status === RetreatState.RUNNING,
    snapshot.lastBellFiredAt ?? 0,
  );

  useArmedWindow(uiState.scheduledAt, uiState.isArmed, uiState.isMissed, dispatchUI);

  return { missedBell };
}
